import { ReportConstant } from '../constants';

const initialState = {};

export default (state = initialState, action) => {
  const { payload: { data, name } = {}, type } = action;
  switch (type) {
    case ReportConstant.SET_REPORT:
      return { ...state, [name]: data };
    default:
      return state;
  }
};
